// extracted by mini-css-extract-plugin
module.exports = {"productImg":"_2P8HgJQwbWYn75Q2BLhaCl","attrEditBtn":"_36-QNLxuyjeLhVwid6qLtg"};